<template>
    <div class="container" v-if="RemenLuxianDetailData">
        <Header status="simple"/>
        <MapTitle :data="mapTitleData" @getCurTab="setCurtab"/>
        <RemenLuxian :RemenLuxianDetailData="RemenLuxianDetailData"/>
    </div>
</template>

<script>
    import Header from "@/components/Common/Header.vue";
    import RemenLuxian from "@/components/ChuyouRemenLuxian.vue";
    import MapTitle from '@/components/Common/MapTitle.vue'


    export default {
        name: "ChuyouRemenLuxian",
        components: {
            Header,
            RemenLuxian,
            MapTitle
        },
        data() {
            return {
                mapTitleData: {
                    title: '2019年7月城市热门路线',
                    tab: ['城市级别', '景区级别', '热门景区']
                },
                curMap: 0,
                RemenLuxianDetailData: null
            };
        },
        computed: {},
        mounted() {
            fetch("/data/JuminChuyou/RemenLuxianDetail.json")
                .then(response => {
                    return response.json();
                })
                .then(json => {
                    this.RemenLuxianDetailData = json.data;
                });
        },
        methods: {
            setCurtab(val) {
                this.curMap = val
                if (this.curMap == 0) {
                    fetch("/data/JuminChuyou/RemenLuxianDetail.json")
                        .then(response => {
                            return response.json();
                        })
                        .then(json => {
                            this.RemenLuxianDetailData = json.data;
                        });
                }
                else {
                    fetch("/data/JuminChuyou/RemenJingquDetail.json")
                        .then(response => {
                            return response.json();
                        })
                        .then(json => {
                            this.RemenLuxianDetailData = json.data;
                        });
                }

            }
        }
    };
</script>
<style scoped lang="less"></style>
